import { Dimensions, StyleSheet, Text, Image, View, TouchableOpacity } from 'react-native'
import theme from '../../../../theme'
import { colorText } from '../../../../themeConstants'
import { isAndroid } from '../../../utils/platformUtils'

const { width, height } = Dimensions.get('window')

const styles = StyleSheet.create({
    invisibleContainer: {
        flex: 1,
        flexDirection: 'column',
        position: 'absolute',
        width: '100%',
        padding: 0,
        bottom: 0,
        justifyContent: 'center',
    },
    feedbackAssetContainer: {
        //marginTop: isAndroid() ? -10 : -10,
        width: isAndroid() ? 40 : 40,
        aspectRatio: 1,
        marginRight: 12,
        marginLeft: 12,
        marginTop: 12,
        alignSelf: 'center',
        zIndex: 2,
    },
    feedbackAsset: {
        width: isAndroid() ? 40 : 40,
        flex: 1,
        borderRadius: 5,
        aspectRatio: 1,
        zIndex: 2,
    },
    container: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: theme.colors.colorPrimary,
        marginTop: 25,
        marginLeft: 0,
        //paddingTop: 10,
        paddingBottom: isAndroid() ? 10 : 20,
        zIndex: 1,
    },
    textTitle: {
        fontSize: 13,
        color: theme.colors.textPrimary,
        color: 'white',
        //marginTop: 5,
        //marginHorizontal: 15,
    },
    textDescription: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        color: 'white',
        //marginHorizontal: 15,
        //marginTop: 5,
        //marginBottom: 15,
    },
    levelKnowledgeBlock: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        marginHorizontal: 0,
        marginTop: 0,
        paddingHorizontal: 10,
        //paddingBottom: isAndroid() ? 10 : 25,
        zIndex: 1,
    },
    titleNextModule: {
        flex: 1,
        fontSize: 14,
        fontWeight: 'normal',
        color: 'white',
        textAlign: 'left',
        marginTop: 10,
        marginRight: 0,
    },
    buttonContainer: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 15,
        bottom: 15,
        width: '100%',
    },
    mainButton: {
        flexDirection: 'row',
        marginTop: 0,
        marginHorizontal: 15,
        backgroundColor: theme.colors.colorPrimary,
        backgroundColor: 'white',
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    mainButtonEvaluationText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    mainButtonRetry: {
        flexDirection: 'row',
        marginTop: 0,
        marginHorizontal: 15,
        backgroundColor: theme.colors.error,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    secondaryButton: {
        flexDirection: 'row',
        marginTop: 8,
        paddingVertical: 5,
        marginRight: 60,
        borderColor: 'white',
        borderWidth: 1.5,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },
    secondaryButtonText: {
        fontSize: 14,
        color: 'white',
        fontWeight: 'bold',
        paddingHorizontal: 15,
        textAlign: 'center',
    },
    finishButton: {
        flexDirection: 'row',
        marginTop: 0,
        marginHorizontal: 15,
        backgroundColor: theme.colors.colorShare,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    iconButton: {
        marginRight: 12,
        marginTop: 12,
        marginBottom: 0,
        alignSelf: 'center',
    },
})

export default styles
